<template>
  <Flex
    direction="column"
    :gap="0.5"
  >
    <BaseTask
      :heading="
        $t(
          `admin.treatwell.main.getting_evaluated.${
            feedbackEnabled
              ? 'feedback_enabled'
              : 'enable_feedback'
          }`
        )
      "
      text=""
      :state="feedbackEnabled ? 'completed' : undefined"
      :buttonIcon="enableSection ? 'external_link' : undefined"
      @click="router.push({ name: 'treatwell-enable-feedback' })"
      @buttonClick="
        router.push({ name: 'treatwell-enable-feedback' })
      "
      v-test="'feedback-todo-item'"
      v-intercom="'mp-dashboard-task-feedback'"
    />
    <BaseTask
      :heading="
        $t('admin.treatwell.main.getting_evaluated.bulk_publish')
      "
      :text="
        !treatwellVenue
          ? $t(
              'admin.treatwell.main.disabled_reasons.venue_required'
            )
          : ''
      "
      :state="
        treatwellStatus.reviewsPublished
          ? 'completed'
          : treatwellVenue
          ? undefined
          : 'blocked'
      "
      :buttonIcon="
        enableSection && treatwellVenue
          ? 'external_link'
          : undefined
      "
      @click="router.push({ name: 'treatwell-publish-batch' })"
      @buttonClick="
        router.push({ name: 'treatwell-publish-batch' })
      "
      v-test="'bulk-push-todo-item'"
      v-intercom="'mp-dashboard-task-bulk-publish'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';
import type { TreatwellVenue } from '@/types';

// Collecting customer feedback and pushing it to the marketplace as reviews
defineProps<{
  treatwellVenue: Partial<TreatwellVenue> | null;
  enableSection: boolean;
}>();

const router = useRouter();
const { treatwellStatus } = storeToRefs(useTreatwellStore());
const { companySettings } = storeToRefs(useCompanyStore());

const feedbackEnabled = computed(
  () => companySettings.value.customers.appointmentFeedback,
);
</script>
